/// <amd-module name="Feed/Legacy/Protocols/Components/PackagePeople" />
import * as React from "react";

import * as PackageResources from "Feed/Common/Resources";
import { PackageAttribute } from "Feed/Legacy/Protocols/Components/PackageAttribute";

export interface IPackagePeopleProps {
    authors: string[];
}

export class PackagePeople extends React.PureComponent<IPackagePeopleProps> {
    public render(): JSX.Element {
        return (
            <div className="package-people">
                <PackageAttribute title={PackageResources.PackagePeople_Title}>
                    <div className="package-group-header" role="heading" aria-level={3}>
                        {PackageResources.PackagePeople_Authors}
                    </div>
                    {this.props.authors.map(author => {
                        return (
                            <div className="package-attribute-item" key={author}>
                                <span className={"package-attribute-item-icon bowtie-icon bowtie-user"} />
                                {author}
                            </div>
                        );
                    })}
                </PackageAttribute>
            </div>
        );
    }
}
